// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.status-plan[data-v-64478e02] {\n  display: flex;\n  padding: 4px 6px;\n  align-items: center;\n  gap: 4px;\n  border-radius: 4px;\n  width: -moz-fit-content;\n  width: fit-content;\n  font-size: 12px;\n}\n.status-plan-container[data-v-64478e02] {\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
